// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindDynamicVoid } from "../schema";

export function serialize_KindDynamicVoid_internal(value: KindDynamicVoid): unknown {
  return ((value: "dynamicVoid"): unknown => {
    return value;
  })(value);
}
export function serialize_KindDynamicVoid(obj: KindDynamicVoid): string {
  return renderJsonWithNumbersAsBigint(serialize_KindDynamicVoid_internal(obj));
}
export function deserialize_KindDynamicVoid_internal(value: unknown): ParserResult<KindDynamicVoid> {
  return ((value: unknown): ParserResult<"dynamicVoid"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "dynamicVoid":
        return { success: true, value: "dynamicVoid" };
      default:
        return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be enum, one of 'dynamicVoid'.` };
    }
  })(value);
}
export function deserialize_KindDynamicVoid(str: string): ParserResult<KindDynamicVoid> {
  return deserialize_KindDynamicVoid_internal(parseJsonWithNumbersAsBigint(str));
}
